export enum SofologyComponentsToIlpQuestionaryNames {
    CustomerTitle = 'customer.name.title',
    CustomerFirstName = 'customer.name.forename',
    CustomerSurname = 'customer.name.surname',
    CustomerPhone = 'customer.telephone',
    BillingAddress = 'customer.address.currentAddress',
    DeliveryAddress = 'loan.otherDeliveryAddress',
    FirstPreviousAddress = 'customer.address.previousAddresses.0',
    BankAccountHolderName = 'customer.banking.accountName',
    DifferentDeliveryAddress = 'differentDeliveryAddress'
}

